import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

export const authenticate = () => {
  const notAuthenticated = {
    isAuthenticated: false,
    token: '',
    currentUser: {},
  };
  if (!localStorage.jwtToken) {
    return notAuthenticated;
  }
  const decoded = jwt_decode(localStorage.jwtToken);
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    localStorage.removeItem('jwtToken');
    return notAuthenticated;
  }
  return {
    isAuthenticated: true,
    token: localStorage.jwtToken,
    currentUser: decoded,
  };
};

const PrivateRoute = ({ component: Component, useAuth, history, ...rest }) => {
  const [auth, setAuth] = useAuth;
  React.useLayoutEffect(() => {
    const authState = authenticate();
    setAuth(authState);
    if (!authState.isAuthenticated) {
      window.location.href = '/login';
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) =>
        auth.isAuthenticated === true ? (
          <Component {...props} />
        ) : (
          <Redirect to='/login' />
        )
      }
    />
  );
};

export default PrivateRoute;
